import { useContext } from "react";
import { ThemeContext } from "../contexts/ThemeContext";

export function useTheme() {
    const value = useContext(ThemeContext)
    return value
}